module.exports = __webpack_public_path__ + "img/search.08c6c3fc.svg";